<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EOvzXx/images/cover.jpg?1701984102366" alt="This image is the cover for the book Britannia's Navy on the West Coast of North America, 1812–1914"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Britannia's Navy on the West Coast of North America, 1812–1914
      </h1>
      <p class="bookDescription body article font2">
        <p>The influence of the Royal Navy on the development of British Columbia and the Pacific Northwest was both extensive and effective. Yet all too frequently, its impact has been ignored by historians, who instead focus on the influence of explorers, fur traders, settlers, and railway builders. In this thoroughly revised and expanded edition of his classic 1972 work, naval historian Barry Gough examines the contest for the Columbia country during the War of 1812, the 1844 British response to the aggressive American agenda of President Polk's Manifest Destiny and cries of Fifty-four forty or fight, the gold-rush invasion of 30,000 outsiders, and the jurisdictional dispute in the San Juan Islands that spawned the so-called Pig War. The author also looks at the Esquimalt-based fleet in the decade before British Columbia joined Canada and the Navy's relationship with coastal indigenous peoples over the five decades that preceded the Great War.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Barry Gough
      </h2>
      
      <p class="authorDescription body article">Canadian historian Barry Gough has published more than eighteen books to critical acclaim, including Historical Dreadnoughts: Arthur Marder, Stephen Roskill and Battles for Naval History; Through Water, Ice & Fire: Schooner Nancy of the War of 1812; and uan de Fucas Strait: Voyages in the Waterway of Forgotten Dreams. For his contributions to civic life in Canada he has received many accolades, including the Queens Golden Jubilee Medal and the Queens Diamond Jubilee Medal. He is president of the British Columbia Historical Federation. He lives in Victoria, British Columbia.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Seaforth Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?77996c02